import { signIn as corporateGroupLogin } from 'next-auth/react';
import { PropsWithChildren, useEffect } from 'react';
import { useFormState } from '../../../../bookings/FormState/useFormState';
import { LinkId } from '../../../AnalyticsContext/LinkId';
import { CorporateGroupIdentityLoginMethod } from '../../../CorporateGroupIdentityConfigProvider/CorporateGroupIdentityConfigProvider';
import { removeParamFromUrl } from '../../../routing/util';
import { useBrowser } from '../../../services/BrowserService';
import { env } from '../../../util/env';
import { Button } from '../../Button/Button';
import { ButtonStyleProps } from '../../Button/Button.styles';
import { LoginMethodIcon } from './LoginMethodIcon';

const AUTO_LOGIN_PARAM = 'attempt_login';

type Props = ButtonStyleProps &
  PropsWithChildren<{
    providerId: string;
    loginMethod: CorporateGroupIdentityLoginMethod;
    showIcon?: boolean;
  }>;

const shouldAttemptLogin = (attemptLoginParam: string | null) =>
  attemptLoginParam && (attemptLoginParam === '1' || attemptLoginParam === 'true');

export const LoginButton = ({
  providerId,
  loginMethod,
  showIcon = false,
  options,
  children,
  ...viewProps
}: Props) => {
  const { window } = useBrowser();
  const { saveSessionState } = useFormState();
  const url = new URL(window?.location.href || env.MEGATRON_HOST);
  const attemptLogin = shouldAttemptLogin(url.searchParams.get(AUTO_LOGIN_PARAM));
  const callbackUrl = attemptLogin ? removeParamFromUrl(url, AUTO_LOGIN_PARAM) : url.href;

  const signIn = () => {
    saveSessionState();
    void corporateGroupLogin(providerId, { callbackUrl }, { ...loginMethod.fields });
  };

  useEffect(() => {
    if (attemptLogin) {
      signIn();
    }
  });

  return (
    <Button
      {...viewProps}
      trackingId={LinkId.HEADER_CORPORATE_GROUP_IDENTITY_LOG_IN}
      leftContent={showIcon && <LoginMethodIcon loginMethod={loginMethod} />}
      options={options}
      onClick={signIn}
    >
      {children}
    </Button>
  );
};
